import { CONFIG_SETTINGS } from 'config.js';

// export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
// export const UPDATE_USER_NAME = 'UPDATE_USER_NAME';
// export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const LOGOUT = 'LOGOUT';
export const UPDATE_ADMIN_ID = 'UPDATE_ADMIN_ID';
export const UPDATE_ADMIN_NAME = 'UPDATE_ADMIN_NAME';
export const UPDATE_FACILITY_ID = 'UPDATE_FACILITY_ID';
export const UPDATE_FACILITY_NAME = 'UPDATE_FACILITY_NAME';

// export const UPDATE_GROUP = 'UPDATE_GROUP';
export const TEMP_SET_USER = 'TEMP_SET_USER';
export const SET_FIREBASE_ROOT = "SET_FIREBASE_ROOT";
export const SET_PLAY_WAKEUP = "SET_PLAY_WAKEUP";



export const tempSetUser = user => {
  return {
    type: TEMP_SET_USER,
    payload: user
  }
}

export const updateFirebaseRoot = param1 => {
  return {
    type: SET_FIREBASE_ROOT,
    payload: param1
  }
}

export const updatePlayWakeup = param1 => {
  return {
    type: SET_PLAY_WAKEUP,
    payload: param1
  }
}

export const updateAdminId = adminId => {
  return {
    type: UPDATE_ADMIN_ID,
    payload: adminId
  }
}

export const updateAdminName = adminName => {
  return {
    type: UPDATE_ADMIN_NAME,
    payload: adminName
  }
}

export const updateFacilityID = facilityId => {
  return {
    type: UPDATE_FACILITY_ID,
    payload: facilityId
  }
}

export const updateFacilityName = facilityName => {
  return {
    type: UPDATE_FACILITY_NAME,
    payload: facilityName
  }
}


// export const updateUserEmail = userEmail => {
//   return {
//     type: UPDATE_USER_EMAIL,
//     payload: userEmail
//   }
// }

// export const updateUserName = userName => {
//   return {
//     type: UPDATE_USER_NAME,
//     payload: userName
//   }
// }

// export const updatePassword = password => {
//   return {
//     type: UPDATE_PASSWORD,
//     payload: password
//   }
// }

// export const updateGroup = group => {
//   return {
//     type: UPDATE_GROUP,
//     payload: group
//   }
// }

export const doLogout = () => {
  
  const newuser = {
    status: '',
    admin_id: '',
    admin_name: '',
    facility_id: '',
    facility_name: '',
    admin_type : '',
    // userEmail: '',
    // password: '',
    // username: '',
    // group: ''
  }

  localStorage.setItem(CONFIG_SETTINGS.USER_INFO, JSON.stringify(newuser) );
  localStorage.setItem(CONFIG_SETTINGS.FIREBASE_ROOT, '');

  localStorage.setItem(CONFIG_SETTINGS.EmergencyRowsPerPage , CONFIG_SETTINGS.DEFAULT_EmergencyRowsPerPage);
  localStorage.setItem(CONFIG_SETTINGS.CautionRowsPerPage, CONFIG_SETTINGS.DEFAULT_CautionRowsPerPage);
  localStorage.setItem(CONFIG_SETTINGS.DeviceRowsPerPage, CONFIG_SETTINGS.DEFAULT_DeviceRowsPerPage);

  return {
    type: LOGOUT,
    payload: newuser
  }
}
